<template>
  <div>
    <v-menu v-model="meta.picker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y lazy full-width max-width="290px" min-width="290px">
      <template v-slot:activator="{ on }">
        <v-text-field v-model="myValue" :rules="ruleFuc(meta)" persistent-hint readonly :label="meta.label" v-on="on" />
      </template>
      <v-date-picker v-model="myValue" no-title @input="meta.picker = false" />
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    meta: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: ''
    },
    ruleFuc: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      myValue: this.value
    }
  },
  watch: {
    value(newVal) {
      this.myValue = newVal
    },
    myValue(newVal) {
      this.$emit('input', newVal)
    }
  }
}
</script>
<style>
.accent {
    background-color: #005caf !important;
    border-color: #005caf !important;
}
.v-btn .v-btn__content .v-icon {
  font-size: 16px !important;
}
</style>
